(function () {
  var MOBILE_BREAKPOINT = 960;
  var AUTO_HEIGHT_DELAY = 50;
  var instances = new WeakMap();
  var autoHeightTimers = new WeakMap();
  var restartFrames = new WeakMap();

  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  };

  var getStartIndex = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return 0;
    }

    if (swiper.params && swiper.params.loop && typeof swiper.realIndex === 'number') {
      return swiper.realIndex;
    }

    return swiper.activeIndex || 0;
  };

  var resetNavInlineStyles = function (section) {
    var prev = section.querySelector('.custom-top-shelf-carousel__nav--prev');
    var next = section.querySelector('.custom-top-shelf-carousel__nav--next');

    if (prev) {
      prev.style.left = '';
    }

    if (next) {
      next.style.left = '';
    }
  };

  var clearSwiperInlineStyles = function (section) {
    var swiperEl = section.querySelector('.custom-top-shelf-carousel__swiper');

    if (!swiperEl) {
      return;
    }

    swiperEl.style.height = '';

    var wrapper = swiperEl.querySelector('.swiper-wrapper');

    if (wrapper) {
      wrapper.style.height = '';
    }
  };

  var forceDestroySwiperElement = function (swiperEl) {
    if (!swiperEl || !swiperEl.swiper) {
      return;
    }

    if (!swiperEl.swiper.destroyed) {
      swiperEl.swiper.destroy(true, true);
    }

    delete swiperEl.swiper;
  };

  var addMediaListener = function (media, handler) {
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', handler);

      return function () {
        media.removeEventListener('change', handler);
      };
    }

    if (typeof media.addListener === 'function') {
      media.addListener(handler);

      return function () {
        media.removeListener(handler);
      };
    }

    return null;
  };

  var cancelScheduledRestart = function (section) {
    var frameId = restartFrames.get(section);

    if (frameId) {
      window.cancelAnimationFrame(frameId);
      restartFrames.delete(section);
    }
  };

  var scheduleRestartCarousel = function (section) {
    cancelScheduledRestart(section);

    restartFrames.set(
      section,
      window.requestAnimationFrame(function () {
        restartFrames.set(
          section,
          window.requestAnimationFrame(function () {
            restartFrames.delete(section);
            restartCarousel(section);
          })
        );
      })
    );
  };

  var resetSwiperInlineHeight = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return;
    }

    if (swiper.wrapperEl) {
      swiper.wrapperEl.style.height = '';
    }

    if (swiper.el) {
      swiper.el.style.height = '';
    }
  };

  var clearAutoHeightTimer = function (section) {
    var timer = autoHeightTimers.get(section);

    if (timer) {
      window.clearTimeout(timer);
      autoHeightTimers.delete(section);
    }
  };

  var scheduleAutoHeightUpdate = function (section, swiper) {
    if (
      !swiper ||
      swiper.destroyed ||
      typeof swiper.updateAutoHeight !== 'function' ||
      !swiper.params.autoHeight
    ) {
      return;
    }

    clearAutoHeightTimer(section);

    autoHeightTimers.set(
      section,
      window.setTimeout(function () {
        autoHeightTimers.delete(section);

        if (!swiper || swiper.destroyed || isDesktop()) {
          return;
        }

        swiper.updateAutoHeight();
      }, AUTO_HEIGHT_DELAY)
    );
  };

  var updateNavPosition = function (section) {
    if (!isDesktop()) {
      return;
    }

    var swiperEl = section.querySelector('.custom-top-shelf-carousel__swiper');
    var referenceSlide = section.querySelector('.custom-top-shelf-carousel__slide');
    var prev = section.querySelector('.custom-top-shelf-carousel__nav--prev');
    var next = section.querySelector('.custom-top-shelf-carousel__nav--next');

    if (!swiperEl || !referenceSlide || !prev || !next) {
      return;
    }

    var styles = getComputedStyle(section);
    var offset = parseFloat(styles.getPropertyValue('--custom-top-shelf-nav-offset')) || 12;
    var viewportCenter = swiperEl.offsetLeft + swiperEl.offsetWidth / 2;
    var slideWidth = referenceSlide.offsetWidth;

    prev.style.left = viewportCenter - slideWidth / 2 - prev.offsetWidth - offset + 'px';
    next.style.left = viewportCenter + slideWidth / 2 + offset + 'px';
  };

  var isCarouselAtStart = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return true;
    }

    if (swiper.params && swiper.params.loop) {
      return getStartIndex(swiper) === 0;
    }

    if (typeof swiper.isBeginning === 'boolean') {
      return swiper.isBeginning;
    }

    return getStartIndex(swiper) === 0;
  };

  var updatePrevNavVisibility = function (section, swiper) {
    var carousel = section.querySelector('.custom-top-shelf-carousel__carousel');
    var prev = section.querySelector('.custom-top-shelf-carousel__nav--prev');

    if (!carousel) {
      return;
    }

    var showPrev = !isCarouselAtStart(swiper);

    carousel.classList.toggle('custom-top-shelf-carousel__carousel--show-prev', showPrev);

    if (!prev) {
      return;
    }

    prev.setAttribute('aria-hidden', showPrev ? 'false' : 'true');
    prev.tabIndex = showPrev ? 0 : -1;
  };

  var resetPrevNavVisibility = function (section) {
    var carousel = section.querySelector('.custom-top-shelf-carousel__carousel');
    var prev = section.querySelector('.custom-top-shelf-carousel__nav--prev');

    if (carousel) {
      carousel.classList.remove('custom-top-shelf-carousel__carousel--show-prev');
    }

    if (prev) {
      prev.removeAttribute('aria-hidden');
      prev.tabIndex = 0;
    }
  };

  var destroyCarouselInstance = function (section, instance) {
    cancelScheduledRestart(section);

    if (instance) {
      if (instance.removeBreakpointListener) {
        instance.removeBreakpointListener();
      }

      if (instance.onResize) {
        window.removeEventListener('resize', instance.onResize);
      }

      resetPrevNavVisibility(section);
      clearAutoHeightTimer(section);

      if (instance.swiper && !instance.swiper.destroyed) {
        instance.swiper.destroy(true, true);
      }

      instances.delete(section);
    }

    var swiperEl = section.querySelector('.custom-top-shelf-carousel__swiper');

    forceDestroySwiperElement(swiperEl);
    clearSwiperInlineStyles(section);
    resetNavInlineStyles(section);
  };

  var restartCarousel = function (section) {
    var instance = instances.get(section);
    var startIndex = instance && instance.swiper ? getStartIndex(instance.swiper) : 0;

    destroyCarouselInstance(section, instance);
    initCarousel(section, startIndex);
  };

  var initCarousel = function (section, startIndex) {
    var swiperEl = section.querySelector('.swiper');

    if (!swiperEl || !window.Swiper) {
      return;
    }

    forceDestroySwiperElement(swiperEl);

    if (swiperEl.swiper) {
      return;
    }

    var blocksCount = parseInt(section.dataset.blocksCount, 10) || 0;
    var enableLoop = blocksCount >= 5;
    var paginationEl = section.querySelector('.custom-top-shelf-carousel__pagination');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      autoHeight: false,
      speed: 800,
      loop: enableLoop,
      spaceBetween: 16,
      watchSlidesProgress: true,
      simulateTouch: true,
      grabCursor: true,
      edgeSwipeDetection: true,
      preventClicks: true,
      preventClicksPropagation: true,
      breakpoints: {
        960: {
          autoHeight: false,
          spaceBetween: '15%',
        },
      },
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return (
                '<span class="' +
                currentClass +
                '"></span>/<span class="' +
                totalClass +
                '"></span>'
              );
            },
          }
        : undefined,
      on: {
        init: function () {
          section.querySelectorAll('.custom-top-shelf-carousel__slide-media img, .custom-top-shelf-carousel__slide-card img').forEach(function (img) {
            img.setAttribute('draggable', 'false');
          });

          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
          resetSwiperInlineHeight(this);
        },
        slideChange: function () {
          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
        },
        slideChangeTransitionEnd: function () {
          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
          resetSwiperInlineHeight(this);
        },
        touchEnd: function () {
          resetSwiperInlineHeight(this);
        },
        resize: function () {
          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
          resetSwiperInlineHeight(this);
        },
      },
    });

    section.querySelectorAll('.custom-top-shelf-carousel__slide-media img').forEach(function (img) {
      if (img.complete) {
        return;
      }

      img.addEventListener(
        'load',
        function () {
          scheduleAutoHeightUpdate(section, swiper);
        },
        { once: true }
      );
    });

    var breakpointMedia = window.matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)');
    var onBreakpointChange = function () {
      scheduleRestartCarousel(section);
    };
    var onResize = function () {
      var currentInstance = instances.get(section);

      if (!currentInstance || !currentInstance.swiper || currentInstance.swiper.destroyed) {
        return;
      }

      updateNavPosition(section);
      updatePrevNavVisibility(section, currentInstance.swiper);
      resetSwiperInlineHeight(currentInstance.swiper);
      currentInstance.swiper.update();
    };

    var removeBreakpointListener = addMediaListener(breakpointMedia, onBreakpointChange);

    window.addEventListener('resize', onResize);

    instances.set(section, {
      swiper: swiper,
      onBreakpointChange: onBreakpointChange,
      removeBreakpointListener: removeBreakpointListener,
      onResize: onResize,
    });

    updateNavPosition(section);
    updatePrevNavVisibility(section, swiper);

    if (typeof startIndex === 'number' && startIndex > 0) {
      window.requestAnimationFrame(function () {
        if (swiper.destroyed) {
          return;
        }

        if (enableLoop && typeof swiper.slideToLoop === 'function') {
          swiper.slideToLoop(startIndex, 0);
        } else {
          swiper.slideTo(startIndex, 0);
        }

        updateNavPosition(section);
        updatePrevNavVisibility(section, swiper);

        if (!isDesktop()) {
          scheduleAutoHeightUpdate(section, swiper);
        } else {
          resetSwiperInlineHeight(swiper);
          swiper.update();
        }
      });
    } else {
      window.requestAnimationFrame(function () {
        if (swiper.destroyed) {
          return;
        }

        updateNavPosition(section);
        updatePrevNavVisibility(section, swiper);

        if (isDesktop()) {
          resetSwiperInlineHeight(swiper);
          swiper.update();
        } else {
          scheduleAutoHeightUpdate(section, swiper);
        }
      });
    }

    return swiper;
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-top-shelf-carousel]').forEach(function (section) {
      initCarousel(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-top-shelf-carousel]').forEach(function (section) {
      var instance = instances.get(section);

      if (instance) {
        destroyCarouselInstance(section, instance);
      }
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
